import React from 'react';
import { Paper, Typography, Divider } from '@mui/material';

/**
 * Mirrors the "GROUP REPORT" section at the bottom of the printed form.
 * If the backend supplies a free-text report (e.g. currentPeriod.group_report
 * or performance record's report field), that is shown verbatim. Otherwise
 * a summary sentence is generated from the totals, same as the previous
 * inline version in PerformanceAnalysis.js.
 */
const GroupReport = ({
  reportText,
  totalCollection,
  memberCount,
  loanCF,
  advCF,
  lsf,
  status,
  isPastPeriod,
  formatCurrency
}) => {
  return (
    <Paper sx={{ p: 2, mt: 3 }} data-testid="group-report">
      <Typography variant="h6" gutterBottom color="primary">
        GROUP REPORT
      </Typography>
      <Divider sx={{ mb: 2 }} />

      {reportText ? (
        <Typography variant="body1" paragraph>
          {reportText}
        </Typography>
      ) : totalCollection !== undefined ? (
        <>
          <Typography variant="body1" paragraph>
            The group has shown performance this period with a total collection of{' '}
            {formatCurrency(totalCollection)}. Total active members: {memberCount}.
            All financial activities have been recorded and calculated for this period.
          </Typography>
          <Typography variant="body1" paragraph>
            Total loans carried forward: {formatCurrency(loanCF)}. Total advances carried
            forward: {formatCurrency(advCF)}. Total savings (LSF): {formatCurrency(lsf)}.
          </Typography>
          <Typography variant="body1">
            Period Status: <strong>{status?.toUpperCase() || 'ACTIVE'}</strong>
            {status === 'closed' && (
              <Typography component="span" sx={{ ml: 1, color: 'success.main' }}>
                - This period has been finalized and locked.
              </Typography>
            )}
            {isPastPeriod && (
              <Typography component="span" sx={{ ml: 1, color: 'info.main' }}>
                - Past period data (auto-updated on access)
              </Typography>
            )}
          </Typography>
        </>
      ) : (
        <Typography>Loading report data...</Typography>
      )}
    </Paper>
  );
};

export default GroupReport;